module.exports = __webpack_public_path__ + "static/media/stepbeats-back@2x.2c86296d.jpg";